<template>
  <generic-modal
    :title="$t('movement list')"
    ref="generic_modal"
    :is_wide="true"
  >
    <generic-table
      ref="datatable"
      :title="$t('account movements')"
      :columns="columns"
      :column_search="true"
      mode="table"
      resource_url="/account/movement/datatables"
      :extra_data="{ uuid: account_uuid }"
    >
    </generic-table>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  generate_datatables_button,
  get_currency_settings,
  format_currency,
  format_date_time,
  confirm_deletion_dialog,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";

export default {
  name: "MovementModal",
  components: { GenericModal, GenericTable },
  data() {
    let v = this;
    return {
      account_uuid: "",
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.create_date) || "";
          },
        },
        {
          title: v.$t("status"),
          width: "10%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.translate_status(row.status_code);
          },
        },
        {
          title: v.$t("type"),
          name: "type",
          searchable: false,
          width: "30%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.movement_type.name || "";
            if (row.movement_type.behavior == "credit") {
              return `<span class="icon has-text-success">
                <i class="fa fa-angle-right"></i>
                </span>
                ${row.movement_type.name}`;
            } else if (row.movement_type.behavior == "charge") {
              return `<span class="icon has-text-danger">
                <i class="fa fa-angle-left"></i>
                </span>
                ${row.movement_type.name}`;
            } else return "¿?";
          },
        },
        {
          title: v.$t("amount"),
          name: "amount",
          searchable: false,
          width: "10%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.amount) || "";
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let r = `<p class="buttons">`;
            if (["V"].includes(row.status_code))
              r += generate_datatables_button({
                args: { uuid: row.uuid },
                tooltip: v.$t("reverse"),
                icon: "fa fa-undo",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to reverse movement?"),
                    v,
                    () => {
                      post("/account/movement", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          console.error(error);
                          error_message(error);
                        });
                    }
                  );
                },
              });
            r = `${r}</p>`;
            return r;
          },
        },
      ],
      error: "",
    };
  },
  computed: {},
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(account_uuid) {
      let v = this;
      v.set_initial_state();
      v.account_uuid = account_uuid;
      setTimeout(() => {
        v.refresh();
      }, 200);
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.account_uuid = "";
      v.error = "";
      v.$refs.datatable.destroy();
      // v.uuid = "";
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "V":
          return v.$t("valid");
        case "X":
          return v.$t("void");
        default:
          return status_code;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
